// src/data/posts.js
import React from 'react';
import InvestingApp from '../components/blogPost/5investingApp'; 
import StockAppStory from '../components/blogPost/StockAppStory';
import CryptoWallets2025 from '../components/blogPost/CryptoWallets2025';
import SmartInvesting30s from '../components/blogPost/SmartInvesting30s';
import BillionairesInvestments2025 from '../components/blogPost/Billionairesinvestements2025';
import TwentyWeekInvesting from '../components/blogPost/20WeekInvestementTrick';

export const posts = [
  {
    slug: '5Investing apps',
    title: '5 Investing Apps That Turned $100 into Thousands in 2025',
    content: (
      <>
        <InvestingApp/>
      </>
    ),
  },
  {
    slug: 'longAndsteady',
    title: 'How I got kinda rich in the stock market',
    content: (
      <>
        <StockAppStory/>
      </>
    ),
  },
  {
    slug: 'Top3cryptowallet',
    title: 'Top 3 Crypto Wallets Every Investor Should Use in 2025',
    content: (
      <>
        <CryptoWallets2025/>
      </>
    ),
  },
  {
    slug: 'DontRetireBroke',
    title: 'Don’t Retire Broke: 5 Ways to Invest Smart in Your 30s',
    content: (
      <>
        <SmartInvesting30s/>
      </>
    ),
  },
  {
    slug: 'What Billionaires Are Buying in 2025 (And You Can Too)',
    title: 'What Billionaires Are Buying in 2025 (And You Can Too)',
    content: (
      <>
        <BillionairesInvestments2025/>
      </>
    ),
  },
  {
    slug: 'Investing',
    title: 'This $80/Week Investing Trick Could Build You a Fortune',
    content: (
      <>
      <TwentyWeekInvesting/>
      </>
    ),
  },
];
